import React from 'react';
import Icon from '@atlaskit/icon';
import { CustomGlyphProps } from '@atlaskit/icon/types';

import { IconProps } from './interface';

const SortDownGlyph = (props: CustomGlyphProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        data-testid={props['data-testid']}
        aria-label={props['aria-label']}
        className={props.className}>
        <path
            d="M13.3377 13.7274L14.25 14.6316L14.25 7.5C14.25 7.08579 14.5858 6.75 15 6.75C15.4142 6.75 15.75 7.08579 15.75 7.5L15.75 14.6316L16.6623 13.7274C16.9683 13.4241 17.4644 13.4241 17.7704 13.7274C18.0765 14.0307 18.0765 14.5225 17.7704 14.8258L15.5541 17.0225C15.248 17.3258 14.7519 17.3258 14.4459 17.0225L12.2295 14.8258C11.9235 14.5225 11.9235 14.0307 12.2295 13.7274C12.5355 13.4241 13.0317 13.4241 13.3377 13.7274ZM6 7.50002C6 7.08581 6.33579 6.75002 6.75 6.75002H11.75C12.1642 6.75002 12.5 7.08581 12.5 7.50002C12.5 7.91423 12.1642 8.25002 11.75 8.25002H6.75C6.33579 8.25002 6 7.91423 6 7.50002ZM6 10.5C6 10.0858 6.33579 9.75001 6.75 9.75001H10.75C11.1642 9.75001 11.5 10.0858 11.5 10.5C11.5 10.9142 11.1642 11.25 10.75 11.25H6.75C6.33579 11.25 6 10.9142 6 10.5ZM6.75 12.75C6.33579 12.75 6 13.0858 6 13.5C6 13.9142 6.33579 14.25 6.75 14.25H9.75C10.1642 14.25 10.5 13.9142 10.5 13.5C10.5 13.0858 10.1642 12.75 9.75 12.75H6.75ZM6 16.5C6 16.0858 6.33579 15.75 6.75 15.75H8.75C9.16421 15.75 9.5 16.0858 9.5 16.5C9.5 16.9142 9.16421 17.25 8.75 17.25H6.75C6.33579 17.25 6 16.9142 6 16.5Z"
            fill="currentColor"
        />
    </svg>

);

const SortDownIcon = (props: IconProps) => {
    return <Icon {...props}  glyph={SortDownGlyph} label={props.label ?? ''}/>;
};

export default SortDownIcon;